(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskDetails', {
    bindings: {
      userTask: '<',
      hideDetails: '&',

      // Will be used to change the task details in the tasks list itself instead of loading the list of tasks again
      setNewDetails: '&'
    },
    controller: UserTaskDetailsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-details.view.html'
  });

  function UserTaskDetailsController(
    accountsService,
    userTasksService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.showActionForm = showActionForm;
    vm.hideActionForm = hideActionForm;
    vm.onFormSubmit = onFormSubmit;

    function onInit() {
      vm.loading = true;
      _loadTaskDetails();
    }

    function showActionForm(formIndex) {
      vm.showFormContainer = true;
      vm.selectedIndex = formIndex;
    }

    function hideActionForm() {
      vm.showFormContainer = false;
      vm.selectedIndex = undefined;
    }

    function onFormSubmit(actionName, newJobDetails) {
      hideActionForm();
      vm.setNewDetails({
        details: newJobDetails
      });
    }

    function _loadTaskDetails() {
      return userTasksService.getTaskDetails(accountsService.currentAccountId, vm.userTask.id).then(function(response) {
        vm.userTaskDetails = response.data.job;
        _showCallDetails(vm.userTaskDetails);
        vm.loading = false;
      });
    }

    function _showCallDetails(taskDetails) {
      vm.showCallDetails = !!taskDetails.publicState['call ID'];
    }

  }
})();
